import { ItemView, util } from '@glu/core';

import template from './rowView.hbs';

export default ItemView.extend({
  template,

  tagName: 'tr',

  serializeData() {
    const columnsIn = this.options.columns;
    const { model } = this;
    const formatProperties = {};
    const columnsOut = [];
    util.each(columnsIn, (columnIn) => {
      const columnOut = util.clone(columnIn);
      if (util.isFunction(columnIn.format)) {
        formatProperties[columnIn.field] = columnIn.format(model.get(columnIn.field), model);
      }
      if (util.isFunction(columnIn.url)) {
        columnOut.url = columnIn.url(model, columnIn);
      }
      columnsOut.push(columnOut);
    });
    return util.extend({
      columns: columnsOut
    }, model.toJSON(), formatProperties);
  }
});
